module.exports = __webpack_public_path__ + "assets/img/home_banner1.6cf0a4f5.png";